import { Articles } from "features/landing/data/models/article";
import FundraiserBlogCard from "../components/fundraiserBlog/fundraiserBlogCard";

const FundraiserBlogGrid = ({ articles }: { articles: Articles[]|undefined }) => {
  return <div className="lg:mt-[70px] mt-[46px] ">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {articles?.map((article) => (
            <FundraiserBlogCard key={article.id} article={article} />
        ))}
    </div>
  </div>;
};

export default FundraiserBlogGrid;